export type ResolvedJsonInput =
  | { kind: 'empty' }
  | { kind: 'plain-text'; text: string }
  | { kind: 'json'; src: object; wasString: boolean };

export function parseJsonValue(raw: unknown): unknown {
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }

  return raw;
}

export function resolveJsonInput(value: unknown): ResolvedJsonInput {
  if (value === null || value === undefined) {
    return { kind: 'empty' };
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (!trimmed) {
      return { kind: 'empty' };
    }

    try {
      const parsed = JSON.parse(trimmed);

      if (typeof parsed === 'object' && parsed !== null) {
        return { kind: 'json', src: parsed as object, wasString: true };
      }

      return { kind: 'plain-text', text: value };
    } catch {
      return { kind: 'plain-text', text: value };
    }
  }

  if (typeof value === 'object') {
    return { kind: 'json', src: value as object, wasString: false };
  }

  return { kind: 'plain-text', text: String(value) };
}

export function formatJsonValue(value: unknown, pretty = true): string {
  const resolved = resolveJsonInput(value);

  if (resolved.kind === 'empty') {
    return '';
  }

  if (resolved.kind === 'plain-text') {
    return resolved.text;
  }

  return pretty
    ? JSON.stringify(resolved.src, null, 2)
    : JSON.stringify(resolved.src);
}

export function serializeJsonOutput(
  src: object,
  originalValue: unknown,
  pretty = true,
): unknown {
  const resolved = resolveJsonInput(originalValue);

  if (resolved.kind === 'json' && resolved.wasString) {
    return pretty ? JSON.stringify(src, null, 2) : JSON.stringify(src);
  }

  if (typeof originalValue === 'string') {
    return pretty ? JSON.stringify(src, null, 2) : JSON.stringify(src);
  }

  return src;
}
